<template>
  <div :class="classes">
    <slot></slot>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  dark: { type: Boolean, required: false, default: false },
  flat: { type: Boolean, required: false, default: false },
});

const classes = computed(() => ({
  'panel': true,
  'panel--dark': props.dark,
  'panel--flat': props.flat,
}));
</script>

<style scoped lang="scss">
@import '@/stylesheets/global';

.panel {
  background: map-get($background-color, lighter);
  border-radius: map-get($border-radius, heavier);
  margin-bottom: bu(3);

  &--dark {
    background-color: map-get($background-color, dark);
  }

  &--flat {
    margin-bottom: 0;
  }
}

</style>
